/**
 * Constants used throughout the chat widget
 */

// ================================
// File Upload Limits
// ================================
// With Backend Proxy approach, we can support larger files (up to ~7MB)
// The limit is constrained by Cloud Functions request body size (~10MB)
// Since base64 adds ~33% overhead, max original file is ~7MB
export const MAX_FILE_SIZE = 7 * 1024 * 1024  // 7MB

// ================================
// Widget Styling
// ================================
export const WIDGET_Z_INDEX = 2147483647
export const WIDGET_WIDTH = '568px'
export const WIDGET_HEIGHT = '520px'
export const DEFAULT_PRIMARY_COLOR = '#6366f1'
export const DEFAULT_GREETING = 'Hi there! How can I help you today?'

// Animation keyframes for unread badge pop-in
export const BADGE_ANIMATION_CSS = `
    @keyframes badge-pop-in {
        0% { transform: scale(0); }
        80% { transform: scale(1.1); }
        100% { transform: scale(1); }
    }
`

// Animation keyframes for typing indicator
export const TYPING_ANIMATION_CSS = `
    @keyframes typing-dot {
        0%, 60%, 100% {
            transform: translateY(0);
            opacity: 0.4;
        }
        30% {
            transform: translateY(-4px);
            opacity: 1;
        }
    }
`
